import css from './exerciseLabel.module.scss';

import cx from 'classnames';
import { memo } from 'react';

import LangIcon from '../LangIcon';
import { Icon } from '../icons';

const arrowRight = <Icon icon="ArrowRight" className={css.labelIcon} />;
const arrowLeft = <Icon icon="ArrowLeft" className={css.labelIcon} />;
const cards = <Icon icon="Cards" className={css.labelIcon} />;

const labels: Record<TExercise, (lang: TLang | null) => React.ReactNode> = {
  [TExercise.wordCards]: lang => (
    <>
      {arrowRight}
      {lang ? <LangIcon className={css.flagIcon} lang={lang} /> : cards}
    </>
  ),
  [TExercise.wordCardsReverse]: lang => (
    <>
      {lang ? <LangIcon className={css.flagIcon} lang={lang} /> : cards}
      {arrowLeft}
    </>
  ),
};

type TProps = {
  exercise: TExercise;
  deckLang: TLang | null;
  className: string;
};
const ExerciseLink: React.FC<TProps> = ({ exercise, deckLang, className }) => (
  <span className={cx(css.root, className)}>{labels[exercise](deckLang)}</span>
);

export default memo(ExerciseLink);
